// src/pages/JoinByCode.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

function fmt(dt){
    try { return new Intl.DateTimeFormat('pl-PL',{dateStyle:'medium', timeStyle:'short'}).format(new Date(dt)); }
    catch { return dt || '—'; }
}
function mapStatus(s){
    const m = {
        created: 'Utworzony',
        pending_verification: 'Weryfikacja',
        in_progress: 'W trakcie',
        submitted: 'Złożony',
        awaiting_manual: 'Oczekuje na ocenę',
        auto_graded: 'Oceniony automatycznie',
        completed: 'Zakończony',
        canceled: 'Unieważniony',
    };
    return m[s] || s || '—';
}

export default function JoinByCode(){
    const [code, setCode] = useState('');
    const [err, setErr] = useState('');
    const [ok, setOk] = useState('');
    const [guestUpcoming, setGuestUpcoming] = useState([]);
    const [guestFinished, setGuestFinished] = useState([]);
    const nav = useNavigate();

    async function loadGuestLists(){
        try{
            const [u, f] = await Promise.all([
                fetch('/api/student/egzaminy/kod/zaplanowane', { credentials:'include', headers:{ ...authHeader() } }),
                fetch('/api/student/terminy/kod/zakonczone',  { credentials:'include', headers:{ ...authHeader() } }),
            ]);
            const ju = u.ok ? await u.json() : [];
            const jf = f.ok ? await f.json() : [];
            setGuestUpcoming(Array.isArray(ju) ? ju : []);
            setGuestFinished(Array.isArray(jf) ? jf : []);
        }catch{ /* no-op */ }
    }

    useEffect(()=>{ loadGuestLists(); }, []);

    async function submit(e){
        e.preventDefault();
        setErr(''); setOk('');
        try{
            if (!code.trim()) throw new Error('Wpisz kod');
            const kind = code.trim().charAt(0).toUpperCase();
            const url = (kind === 'T') ? '/api/student/join/term' : (kind === 'G' ? '/api/student/grupy/join-code' : null);
            if (!url) throw new Error('Nieprawidłowy kod (oczekiwano prefiksu T lub G)');

            const r = await fetch(url, {
                method:'POST',
                credentials:'include',
                headers:{ 'Content-Type':'application/json', ...authHeader() },
                body: JSON.stringify({ code: code.trim() })
            });
            const j = await r.json().catch(()=> ({}));
            if (!r.ok) throw new Error(j?.blad || `Błąd (${r.status})`);

            if (kind === 'T') {
                setOk('Dołączono do terminu. Możesz rozpocząć zgodnie z harmonogramem.');
            } else {
                setOk('Zapis do grupy prawidłowy.');
                setCode('');
                setTimeout(() => nav(`/student/grupa/${j.group_id}`), 800);
                return;
            }
            setCode('');
            await loadGuestLists();
        }catch(e){ setErr(e.message || 'Błąd'); }
    }

    return (
        <div style={{ maxWidth: 900, padding:'0 16px', marginTop:80 }}>
            <h1 style={{ marginTop:50, marginBottom:20 }}>Dołącz do egzaminu za pomocą kodu</h1>

            <form onSubmit={submit} style={{ display:'grid', gap:12, marginBottom:20 }}>
                <label style={{ display:'grid', gap:6 }}>
                    <span>Kod (np. <code>TABCDE12</code> albo <code>G0F1E2D3</code>)</span>
                    <input
                        value={code}
                        onChange={e=>setCode(e.target.value)}
                        placeholder="Wpisz kod od prowadzącego"
                        style={{
                            minHeight: 48,
                            padding: '12px 14px',
                            border: '1px solid #d1d5db',
                            borderRadius: 8,
                            fontSize: 18,
                            lineHeight: 1.3,
                            letterSpacing: 0,
                            textTransform: 'uppercase',
                        }}
                    />
                </label>
                <div style={{ display:'flex', gap:8 }}>
                    <button className={'but-smal'} type="submit">Dołącz</button>
                </div>
                {ok && <div style={{ color:'#059669' }}>{ok}</div>}
                {err && <div style={{ color:'#dc2626' }}>{err}</div>}
            </form>

            <h2 style={{ margin:'16px 0 8px' }}>Nadchodzące — dołączono kodem</h2>
            {guestUpcoming.length === 0 ? (
                <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:14, color:'#6b7280' }}>
                    Brak nadchodzących egzaminów dołączonych kodem.
                </div>
            ) : (
                <div style={{ display:'grid', gap:10 }}>
                    {guestUpcoming.map(t => (
                        <div key={t.attempt_id}
                             style={{ border:'1px solid #e5e7eb', borderRadius:12, padding:12, background:'#fff',
                                 display:'flex', justifyContent:'space-between', alignItems:'center', gap:12 }}>
                            <div>
                                <div style={{ fontWeight:700 }}>{t.title || 'Egzamin'}</div>
                                <div style={{ color:'#6b7280', fontSize:14 }}>
                                    {fmt(t.exam_datetime)} • {t.exam_duration} min • Proctoring: {t.proctoring ? 'tak':'nie'}
                                </div>
                            </div>
                            <button className={'but-smal'}
                                    onClick={()=> nav(`/student/egzamin/termin/${t.term_id}/start`)}
                                    style={{ padding:'8px 12px' }}>
                                Przejdź
                            </button>
                        </div>
                    ))}
                </div>
            )}

            <h2 style={{ margin:'20px 0 8px' }}>Zakończone — dołączono kodem</h2>
            {guestFinished.length === 0 ? (
                <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:14, color:'#6b7280' }}>
                    Brak zakończonych egzaminów dołączonych kodem.
                </div>
            ) : (
                <div style={{ display:'grid', gap:10 }}>
                    {guestFinished.map(t => (
                        <div key={t.attempt_id}
                             style={{ border:'1px solid #e5e7eb', borderRadius:12, padding:12, background:'#fff',
                                 display:'flex', justifyContent:'space-between', alignItems:'center', gap:12 }}>
                            <div>
                                <div style={{ fontWeight:700 }}>{t.title || 'Egzamin'}</div>
                                <div style={{ color:'#6b7280', fontSize:14 }}>
                                    {fmt(t.exam_datetime)} • {t.exam_duration} min • Proctoring: {t.proctoring ? 'tak':'nie'} • Status: {mapStatus(t.attempt_status)}
                                </div>
                            </div>
                            <button className={'but-smal'}
                                    onClick={()=> nav(`/student/egzamin/${t.attempt_id}/wyniki`)}
                                    style={{ padding:'8px 12px' }}>
                                Wyniki
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
